/**
 * Supported language codes
 */
export enum LanguageCode {
  EN = 'en',
  FA = 'fa',
}

/**
 * Default language for the application
 */
export const DEFAULT_LANGUAGE = LanguageCode.EN;

/**
 * Check if a string is a valid LanguageCode
 */
export function isValidLanguageCode(code: string): code is LanguageCode {
  return Object.values(LanguageCode).includes(code as LanguageCode);
}

/**
 * Get human-readable label for a language code
 */
export function getLanguageLabel(code: LanguageCode): string {
  const labels: Record<LanguageCode, string> = {
    [LanguageCode.EN]: 'English',
    [LanguageCode.FA]: 'فارسی (Farsi)',
  };
  return labels[code];
}

/**
 * Get all available language codes
 */
export function getAllLanguageCodes(): LanguageCode[] {
  return Object.values(LanguageCode);
}
